module["exports"] = ["#{street_prefix} #{street_suffix}"];